import React from 'react';
import CommerceDocPublicPage from './CommerceDocPublicPage';

export default function QuotationPublic() {
  return <CommerceDocPublicPage mode="quotation" />;
}
